const ChangePassword = () => {
  return (
    <>
      <h3 class="ct_fs_32 ct_switzer_bold mb-5">Change Password</h3>
      <form action="">
        <div class="row">
          <div class="col-lg-9">
            <div class="form-group mb-4">
              <label for="" class="mb-2 ct_fw_400 ct_fs_16">
                Current Password
              </label>
              <div class="position-relative">
                <input
                  type="password"
                  placeholder="*********"
                  class="form-control ct_input ct_input_pe_40"
                />
                <i class="fa-solid fa-eye-slash ct_show_eye"></i>
              </div>
              <span class="ct_text_red mt-2 d-none">
                Please Enter Current Password
              </span>
            </div>
          </div>
          <div class="col-lg-9">
            <div class="form-group mb-4">
              <label for="" class="mb-2 ct_fw_400 ct_fs_16">
                New Password
              </label>
              <div class="position-relative">
                <input
                  type="password"
                  placeholder="*********"
                  class="form-control ct_input ct_input_pe_40"
                />
                <i class="fa-solid fa-eye-slash ct_show_eye"></i>
              </div>
              <span class="ct_text_red mt-2 d-none">
                Please Enter New Password
              </span>
            </div>
          </div>
          <div class="col-lg-9">
            <div class="form-group mb-4">
              <label for="" class="mb-2 ct_fw_400 ct_fs_16">
                Confirm Password
              </label>
              <div class="position-relative">
                <input
                  type="password"
                  placeholder="*********"
                  class="form-control ct_input ct_input_pe_40"
                />
                <i class="fa-solid fa-eye-slash ct_show_eye"></i>
              </div>
              <span class="ct_text_red mt-2 d-none">
                Please Enter Confirm Password
              </span>
            </div>
          </div>
        </div>

        <div class="d-flex gap-3 mt-4">
          <button class="ct_green_bnt" type="button">
            Save Changes
          </button>
          <button class="outline_btn" type="button">
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};

export default ChangePassword;
